import { render, staticRenderFns } from "./VIcon.vue?vue&type=template&id=744da1ff&"
import script from "./VIcon.vue?vue&type=script&lang=ts&"
export * from "./VIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports